<section class="rounded-lg bg-primary-50 p-4">
  <form
    [formGroup]="transportFormService.transportForm"
    class="flex flex-col gap-4"
  >
    <div>
      <h4 class="text-primary-900">
        {{ "prestation.distanceForm.title" | transloco }}
      </h4>
      <p class="text-paragraph-xs-reg">
        {{ "prestation.distanceForm.subtitle" | transloco }}
      </p>
    </div>
    <div class="flex flex-1 flex-col">
      <label for="distance" class="text-paragraph-xs-med text-greyscale-700">
        {{ "calculator.distance" | transloco }}
      </label>
      <p-inputNumber
        id="distance"
        formControlName="distance"
        [fluid]="true"
        suffix="km"
      />
      <app-error
        [control]="transportFormService.transportForm.get('distance')!"
      />
    </div>
  </form>
</section>
